export const FETCH_CLIENT_USERS_MIGRATION_REQUEST = 'FETCH_CLIENT_USERS_MIGRATION_REQUEST';
export const FETCH_CLIENT_USERS_MIGRATION_SUCCESS = 'FETCH_CLIENT_USERS_MIGRATION_SUCCESS';
export const FETCH_CLIENT_USERS_MIGRATION_FAILURE = 'FETCH_CLIENT_USERS_MIGRATION_FAILURE';

export const POST_CLIENT_USERS_MIGRATION_REQUEST = 'POST_CLIENT_USERS_MIGRATION_REQUEST';
export const POST_CLIENT_USERS_MIGRATION_SUCCESS = 'POST_CLIENT_USERS_MIGRATION_SUCCESS';
export const POST_CLIENT_USERS_MIGRATION_FAILURE = 'POST_CLIENT_USERS_MIGRATION_FAILURE';

export const FETCH_CLIENT_CONTACT_MIGRATION_HISTORY_REQUEST = 'FETCH_CLIENT_CONTACT_MIGRATION_HISTORY_REQUEST';
export const FETCH_CLIENT_CONTACT_MIGRATION_HISTORY_SUCCESS = 'FETCH_CLIENT_CONTACT_MIGRATION_HISTORY_SUCCESS';
export const FETCH_CLIENT_CONTACT_MIGRATION_HISTORY_FAILURE = 'FETCH_CLIENT_CONTACT_MIGRATION_HISTORY_FAILURE';